import { render } from "./RealtorsNotifications.vue?vue&type=template&id=67bde4b8&scoped=true&ts=true"
import script from "./RealtorsNotifications.vue?vue&type=script&lang=ts"
export * from "./RealtorsNotifications.vue?vue&type=script&lang=ts"

import "./RealtorsNotifications.vue?vue&type=style&index=0&id=67bde4b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bde4b8"]])

export default __exports__